/**
 * Decorative background showing the official Jumlaty (جُملتي) brand medallion
 * centered behind every authenticated portal (customer, driver, mujahez, admin).
 * No animation, pointer-events disabled.
 */
const JumlatyBackground = () => {
  return (
    <div
      aria-hidden
      data-testid="jumlaty-bg"
      className="fixed inset-0 -z-10 overflow-hidden pointer-events-none"
      style={{
        background:
          "linear-gradient(140deg, #EAF6FF 0%, #DCEEFF 35%, #F4FAFF 70%, #E8F3FF 100%)",
      }}
    >
      {/* Soft radial glows for depth */}
      <div
        className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full opacity-25"
        style={{ background: "radial-gradient(circle, #7DBDFF 0%, transparent 70%)" }}
      />
      <div
        className="absolute -bottom-40 -left-40 w-[600px] h-[600px] rounded-full opacity-20"
        style={{ background: "radial-gradient(circle, #4A90E2 0%, transparent 70%)" }}
      />

      {/* Centered brand logo — clearly visible but soft enough to keep UI readable */}
      <img
        src="/jumlaty-logo.jpg"
        alt=""
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 select-none"
        style={{
          width: "min(70vw, 560px)",
          height: "auto",
          aspectRatio: "1 / 1",
          objectFit: "contain",
          opacity: 0.35,
          filter: "drop-shadow(0 12px 32px rgba(30, 58, 95, 0.25))",
          borderRadius: "50%",
        }}
        draggable={false}
      />
    </div>
  );
};

export default JumlatyBackground;
